import styled from "styled-components";
import { navyCard } from "../../../../style/styled-components/mixins";
import branchImage2 from "../../../../resources/images/background/intro/branch2.png";
// 지점 페이지 하단 GLOBAL NETWORK (해외 협업 파트너)
const GlobalBranches = () => {
  return (
    <Div>
      <ul>
        <li>
          <b>미국(뉴욕, LA)</b>
          <span>B&amp;H관세법인, J.J.KIM &amp; Associates와 협업 MOU 체결</span>
        </li>
        {/* <li>
          <b>이탈리아</b>
          <span>jus&amp;Trade, MOU 체결</span>
        </li> */}
        <li>
          <b>중국</b>
          <span>신하이 관세법인 MOU 체결</span>
        </li>
      </ul>
      <img src={branchImage2} alt="" />
    </Div>
  );
};
export default GlobalBranches;
const Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2.5rem;
  & > ul {
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%;
    max-width: 65rem;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));
    gap: 1rem;
    & > li {
      ${navyCard}
      display: flex;
      flex-direction: column;
      gap: 0.4rem;
      padding: 1.75rem;
      & > b {
        font-size: 1.3rem;
      }
      & > span {
        color: rgba(255, 255, 255, 0.75);
      }
    }
  }
  & > img {
    width: min(100%, 50rem);
  }
`;
